export const API_QUERY_KEYS = {
  getConsultationDocument: 'getConsultationDocument',
  getAuditRequests: 'getAuditRequests',
  getCaseDetails: 'getCaseDetails',
  getConsultation: 'getConsultation',
  getConsultations: 'getConsultations',
  getConsulteePermission: 'getConsulteePermission',
  getConsultees: 'getConsultees',
  getConsulteeTeams: 'getConsulteeTeams',
  getDfiAnnualReport: 'getDfiAnnualReport',
  getTqEnAnnualReport: 'getTqEnAnnualReport',
  getDfiAnnualReports: 'getDfiAnnualReports',
  getFilterAuthorities: 'getFilterAuthorities',
  getFilterCategories: 'getFilterCategories',
  getFilterConsultationTypes: 'getFilterConsultationTypes',
  getFilterStatuses: 'getFilterStatuses',
  getExtensionRequestStatuses: 'getExtensionRequestStatuses',
  getExtensionRequestsReport: 'getExtensionRequestsReport',
  getMap: 'getMap',
  getManageTeamConsultees: 'getManageTeamConsultees',
  getAllTeams: 'getAllTeams',
  getParentOrganisation: 'getParentOrganisation',
  getParentOrganisations: 'getParentOrganisations',
  getAllParentOrganisations: 'getAllParentOrganisations',
  getPermissions: 'getPermissions',
  getReasonsForLateResponse: 'getReasonsForLateResponse',
  getResponseTypes: 'getResponseTypes',
  getResponses: 'getResponses',
  getStatisticsReport: 'getStatisticsReport',
  getLateResponsesReport: 'getLateResponsesReport',
  getOutstandingResponsesReport: 'getOutstandingResponsesReport',
  getRespondedOnTimeReport: 'getRespondedOnTimeReport',
  getRespondedYearToDateReport: 'getRespondedYearToDateReport',
  getTQAdmins: 'getTQAdmins',
  getManageConsultees: 'getManageConsultees',
  getTeams: 'getTeams',
  getIncomingConsultations: 'getIncomingConsultations',
  getSortOptions: 'getSortOptions',
  getExceptionLogs: 'getExceptionLogs',
  getExceptionLogDetails: 'getExceptionLogDetails',
};
